module.exports = __webpack_public_path__ + "img/gonglue.01e2bd8d.png";